import * as signalR from '@microsoft/signalr';
import { getNotificationsHubUrl } from './apiConfig';
import { getStoredAccessToken } from './apiClient';

export type NotificationReceivedPayload = {
  id: string;
  type: string;
  title: string;
  message: string;
  actionUrl?: string | null;
  timestamp: string;
};

export function createNotificationHubConnection(
  onNotification: (payload: NotificationReceivedPayload) => void,
): signalR.HubConnection {
  const connection = new signalR.HubConnectionBuilder()
    .withUrl(getNotificationsHubUrl(), {
      accessTokenFactory: () => getStoredAccessToken() ?? '',
    })
    .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
    .configureLogging(signalR.LogLevel.Warning)
    .build();

  connection.on('NotificationReceived', (payload: NotificationReceivedPayload) => {
    onNotification(payload);
  });

  return connection;
}

export async function startNotificationHubConnection(
  connection: signalR.HubConnection,
): Promise<void> {
  if (connection.state === signalR.HubConnectionState.Connected) {
    return;
  }

  if (connection.state === signalR.HubConnectionState.Connecting) {
    return;
  }

  await connection.start();
}
